/**
 * Defense Audio System — Web Audio API sound functions for threat alerts.
 *
 * Named sound functions for each defense event type.
 * Uses shared AudioContext from audioContext.ts.
 */

import { playTone } from './audioContext';

/** Single ping — threat escalation to caution */
export function playCautionTone(): void {
  playTone(600, 0.15, 0.3);
}

/** Double ping — threat escalation to danger */
export function playDangerTone(): void {
  playTone(800, 0.1, 0.3);
  setTimeout(() => playTone(800, 0.1, 0.3), 150);
}

/** Soft relief tone — position exits danger */
export function playReliefTone(): void {
  playTone(400, 0.2, 0.15);
}

/** Triple staccato — ripcord executed */
export function playRipcordTone(): void {
  playTone(1000, 0.05, 0.3);
  setTimeout(() => playTone(1000, 0.05, 0.3), 100);
  setTimeout(() => playTone(1000, 0.05, 0.3), 200);
}
